import React from 'react';
import withIcon from '../utilities/withIcon';

const IconArrowSkip = () => {
  return (
    <g>
      <path d="M7.75 2c3.368 0 6.125 2.56 6.246 5.78L14 8v3.504l.785-.793.08-.07a.706.706 0 0 1 .927.07c.25.253.275.647.075.928l-.075.09-2.039 2.06-.079.067.007-.005-.008.008a.712.712 0 0 1-.006.005l.001-.003-.032.024a.706.706 0 0 1-.341.114h-.02l-.03.001-.04-.001a.707.707 0 0 1-.34-.113l-.034-.025.002.003a.712.712 0 0 1-.006-.005l-.007-.006-.016-.012a.721.721 0 0 1-.057-.052l-2.039-2.06a.725.725 0 0 1 0-1.018.706.706 0 0 1 .927-.07l.08.07.785.793V8c0-2.477-2.119-4.5-4.75-4.5-2.558 0-4.632 1.912-4.745 4.295L3 8v1.628a2.25 2.25 0 1 1-1.5 0V8c0-3.322 2.806-6 6.25-6zm0 7.5a2.25 2.25 0 1 1 0 4.5 2.25 2.25 0 0 1 0-4.5zm0 1.5a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5z" />
    </g>
  );
};

export default withIcon(IconArrowSkip);
